import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import type {
  Arrangement,
  Product,
} from 'redux/PDP/arrangement/types/arrangement.types';

type State = {
  isOpen: boolean;
  arrangement?: Arrangement;
  selectedProduct?: Product;
  quantity: number;
  sequence: number;
};

const initialState: State = {
  isOpen: false,
  quantity: 1,
  sequence: 0,
};

const slice = createSlice({
  name: 'cyo-bundle/product-modal',
  initialState,
  reducers: {
    openProductModal: (
      state,
      {
        payload: { arrangement, selectedProduct, sequence },
      }: PayloadAction<{
        arrangement: Arrangement;
        selectedProduct: Product;
        sequence: number;
      }>,
    ) => {
      state.isOpen = true;
      state.sequence = sequence;
      state.arrangement = arrangement;
      state.selectedProduct = selectedProduct;
    },
    selectProduct: (state, { payload }: PayloadAction<Product>) => {
      state.selectedProduct = payload;
    },
    setQuantity: (state, { payload }: PayloadAction<number>) => {
      state.quantity = payload;
    },
    closeProductModal: () => initialState,
  },
});

export const {
  openProductModal,
  selectProduct,
  setQuantity,
  closeProductModal,
} = slice.actions;
export const productModelReducer = slice.reducer;
